// Типы данных вкладки «Задачи» отдела IT (эндпоинты /it-projects).
// Модули «IT-проекты» и «Дашборд IT» удалены из портала 2026-07-28 — типы их
// тепловой карты (продукты, конкуренты, этапы, ячейки, категории, референсы)
// убраны вместе с ними. Осталось то, что рисует «Задачи»: «переезд отделов»
// и календарь.

// Прогресс перевода отдела с Google-таблиц на портал (виджет во вкладке «Задачи»).
export type ItprDeptMigration = {
  dept_key: string;
  title: string;
  total_tables: number;
  migrated_tables: number;
  note: string;
};

// Конкретная Google-таблица отдела и куда она переехала в портал.
// "excluded" — таблица в списке, но НЕ учитывается в счётчике X/Y.
export type ItprDeptTableStatus = "not_started" | "in_progress" | "migrated" | "excluded";
export type ItprDeptTable = {
  id: number;
  dept_key: string;
  name: string;
  source_url: string;
  status: ItprDeptTableStatus;
  target_module: string;  // legacy (одиночная вкладка)
  target_tab: string;     // legacy
  target_tabs: string[];  // вкладки отдела «куда»: "topKey" | "topKey::childKey"
  target_label: string;
  target_url: string;
  sort_order: number;
};
export const ITPR_TABLE_STATUS: Record<ItprDeptTableStatus, { label: string; color: string }> = {
  not_started: { label: "не начата", color: "#64748b" },
  in_progress: { label: "в процессе", color: "#f59e0b" },
  migrated: { label: "мигрировала", color: "#10b981" },
  excluded: { label: "не переносится", color: "#94a3b8" },
};

// ── Нативные события календаря ────────────────────────────────────────────────
export interface CalendarPerson {
  id: string;
  name: string;
  avatar: string;
  department: string;
}
export type RecurFreq = "" | "daily" | "weekly" | "monthly" | "yearly";
export interface NativeCalendarEvent {
  id: number;
  title: string;
  date: string;            // дата вхождения "YYYY-MM-DD"
  base_date: string;       // дата мастер-события (для редактора)
  all_day: boolean;
  time: string | null;     // "HH:MM"
  end: string | null;      // "HH:MM"
  description: string;
  location: string;
  color: string | null;
  created_by: string;
  created_by_name: string;
  can_edit: boolean;
  participants: CalendarPerson[];
  recur_freq: RecurFreq;
  recur_interval: number;
  recur_until: string;
  recur_byday: number[];
  recurring: boolean;
  native: true;
}
export interface NativeEventInput {
  title: string;
  date: string;
  all_day: boolean;
  time?: string;
  end?: string;
  description?: string;
  location?: string;
  color?: string;
  participant_ids?: string[];
  recur_freq?: RecurFreq;
  recur_interval?: number;
  recur_until?: string;
  recur_byday?: number[];
}
export const RECUR_OPTIONS: { value: RecurFreq; label: string }[] = [
  { value: "", label: "Не повторяется" },
  { value: "daily", label: "Каждый день" },
  { value: "weekly", label: "Каждую неделю" },
  { value: "monthly", label: "Каждый месяц" },
  { value: "yearly", label: "Каждый год" },
];
export const WEEKDAYS_SHORT = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];
// Палитра цветов события (для пикера).
export const EVENT_COLORS = ["#8b5cf6", "#0ea5e9", "#10b981", "#f59e0b", "#ec4899", "#ef4444", "#6366f1"];
